export const EXPORE_ETF_LIST_DATA = "EXPORE_ETF_LIST_DATA";
export const EXPORE_ETF_LIST_ERROR = "EXPORE_ETF_LIST_ERROR";
export const EXPORE_ETF_LIST_HIDE_ERROR = "EXPORE_ETF_LIST_HIDE_ERROR";
export const EXPORE_ETF_LIST_START_LOADER = "EXPORE_ETF_LIST_START_LOADER";
export const EXPORE_ETF_LIST_STOP_LOADER = "EXPORE_ETF_LIST_STOP_LOADER";
